import React from "react";
import UIText from "./UIText";

const UILink = ({ children, style, className, onClick = () => {} }) => {
  return (
    <div
      style={{
        cursor: "pointer",
        ...style,
      }}
      className={`uiLink ${className}`}
      onClick={onClick}
    >
      <UIText>{children}</UIText>
    </div>
  );
};

export default UILink;
